<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/16xzWoG/tc-custom/9781421402826.jpg?1696566117629" alt="This image is the cover for the book Keeping Your Child Healthy in a Germ-Filled World, A Johns Hopkins Press Health Book"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Keeping Your Child Healthy in a Germ-Filled World, A Johns Hopkins Press Health Book
      </h1>
      <p class="bookDescription body article font2">
        <b>A “well written and easily comprehended” guide to the microbes in our midst—and how to protect kids from infections (<i>Pediatric Infectious Disease Journal</i>).</b><br/><br/> We’re all too aware that the world is full of germs—viruses old and new, parasites, fungi, bacteria that sometimes evolve into antibiotic-resistant superbugs. But the truth is that while infections are harmful, not all germs are bad. In fact, some of them we can’t live without.<br/><br/> In this book a pediatrician who specializes in infectious diseases gives parents the clear information they need to keep their families healthy—without panicking or going overboard. Dr. Athena P. Kourtis sorts through topics including antibiotics, vaccines, hygiene, health foods, and home remedies, and identifies which rules to follow—and which ones to ignore. She says:<br/><br/> • No to overprotecting your children from germs<br/> • No to antimicrobial soaps and cleaning products at home<br/> • No to over-prescribed antibiotics<br/> • Yes to strategic hand washing<br/> • Yes to being conscious of germs and the pathways they use<br/> • Yes to vaccines<br/><br/> She offers tips for protecting children at home, in school, at meals, on the playground, on trips, while playing sports—and answers questions that commonly worry parents. How many times should you wash prewashed spinach? (At least twice.) Does getting enough sleep help fight infection? (Yes.) Are pre-sliced foods more likely to spread infection? (They are.) This comprehensive guide is the first step in helping you and your child stay afloat in the microbial sea.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Athena P. Kourtis
      </h2>
      
      <p class="authorDescription body article">Athena P. Kourtis, M.D., Ph.D., M.P.H., is a pediatrician and infectious diseases specialist, a scientist at the Centers for Disease Control and Prevention, and an associate professor of pediatrics at the Emory University School of Medicine in Atlanta, Georgia, where she has practiced, taught, and researched pediatric infections for the past fifteen years. Dr. Kourtis has written nearly 100professional publications, books, and book chapters on infections in children and has received many national and international awards for her work.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The Johns Hopkins University Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?666733ae